import React, { useEffect, useCallback } from 'react';
import useAnimationStore from '../../../../common/store/useAnimationStore';

const useAnimation = (mask: React.RefObject<HTMLDivElement>, container: React.RefObject<HTMLDivElement>) => {
  const timeline = {
    mask: useAnimationStore(useCallback(state => state.landing.somersby.mask, [])),
    container: useAnimationStore(useCallback(state => state.landing.somersby.container, []))
  }

  useEffect(() => {
    timeline.mask
      .to(mask.current, { duration: 2, ease: "power2.out", opacity: 0 })
      .to(mask.current, { duration: 0, display: "none" });

    timeline.container
      .to(container.current, { duration: 2, ease: "power2.out", y: "0vh" });

    return () => {
      timeline.mask.clear();
      timeline.container.clear();
    }
  }, []);
}

export default useAnimation;